import { VFC, memo, useRef } from "react";
import {
  useDisclosure,IconButton,Text,Flex,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { Navigation } from "../molecules/Navigation";

export const DrawerMenu: VFC = memo(() => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <Flex alignItems="center">
      <IconButton
        ref={btnRef}
        onClick={onOpen}
        aria-label="メニューボタン"
        icon={<HamburgerIcon />}
        display={{ base: "block" }}
        variant="unstyled"
        size="sm"
      />
      <Drawer placement="left" size="xs" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>操作メニュー</DrawerHeader>
            <DrawerBody>
              <Navigation onClose={onClose} />
              
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
      <Text color="yellow" fontSize="xs">{'[Menu]　'}</Text>
    </Flex>
  );
});
